import {Observable} from 'rxjs';

import {combineEpics} from 'web-app/util/redux-observable';
import {
    fetchKikuRelations,
    fetchChildContactsObservable,
    updateChildContactObservable,
    updateKikuRelation,
} from 'web-app/react/entities/contacts/epics';
import {fetchAllBillPayersObservable} from 'web-app/react/entities/bill-payers/epics';

import * as Actions from './actions';

const fetch = action$ =>
    action$.ofType(Actions.fetch.type).mergeMap(({payload}) =>
        Observable.zip(
            fetchChildContactsObservable(payload.childId),
            payload.withKiku ? fetchKikuRelations(payload.childId) : Observable.of({}),
            payload.fetchBillPayers && payload.institutionId
                ? fetchAllBillPayersObservable(payload.institutionId, payload.childId, {includeRecipients: true})
                : Observable.of({}),
        )
            .flatMap(actions => [...actions.filter(a => a.type), Actions.fetchSuccess.action()])
            .catch(e => Observable.of(Actions.fetchFailed.action(e))),
    );

const update = action$ =>
    action$.ofType(Actions.update.type).mergeMap(({payload}) =>
        Observable.zip(
            updateChildContactObservable(
                payload.data,
                payload.shouldUpdateSsn,
                payload.shouldUpdateAddress,
                payload.ssnToken,
            ),
            payload.withKiku
                ? updateKikuRelation(payload.data.relationId, payload.data.kikuRelation)
                : Observable.of({}),
        )
            .flatMap(actions => [...actions.filter(a => a.type), Actions.updateSuccess.action()])
            .catch(e => Observable.of(Actions.updateFailed.action(e))),
    );

export default combineEpics(fetch, update);
